import React from 'react';
import PropTypes from 'prop-types';
import { CustomButton } from '../../../atoms';
import classes from './CfButtonSection.module.scss';

const CfButtonSection = (props) => {
    const {
        formBlockData,
        studentDetails,
        isStudentVerified,
        studentDetailsApiCount,
        isOtpVerified,
        isFormSubmitApiLoading,
        // New props for primary identifier
        isPrimaryIdentifierFlow,
        isPrimaryOtpVerified,
    } = props;

    const isActiveStudent = studentDetails?.stud_bd?.status === 'ACTIVE' || false;
    const mobileInput = formBlockData?.fields?.flat()?.find((field) => field?.input_id === 'customer_mobile');
    const emailInput = formBlockData?.fields?.flat()?.find((field) => field?.input_id === 'customer_email');

    const blockUnverifiedStudent = formBlockData?.form_config?.block_unverified_student ?? false;
    const enableMobileOtpVerification = formBlockData?.form_config?.enable_otp_verification ?? false;
    const enableEmailOtpVerification = formBlockData?.form_config?.enable_email_otp_verification ?? false;

    const renderFormButton = () => {
        // Handle primary identifier flow
        if (isPrimaryIdentifierFlow) {
            // Get primary identifier type
            const primaryIdentifier = formBlockData?.form_config?.primary_identifier;
            const isPrimaryMobile = primaryIdentifier === 'customer_mobile';
            const isPrimaryEmail = primaryIdentifier === 'customer_email';
            
            // Check if OTP is required for primary identifier
            const primaryOtpRequired = (isPrimaryMobile && enableMobileOtpVerification) || 
                                       (isPrimaryEmail && enableEmailOtpVerification);
            
            if (primaryOtpRequired) {
                // If primary OTP is required, only check primary OTP completion
                if (isPrimaryOtpVerified) {
                    return (
                        <CustomButton
                            type="submit"
                            text="Proceed To Pay"
                            className={classes.PaymentForm__Submit}
                            isLoading={isFormSubmitApiLoading}
                        />
                    );
                } else {
                    return null;
                }
            } else {
                // If primary OTP is not required, check for customer OTP requirement
                let customerOtpRequired = false;
                if (isPrimaryMobile && enableEmailOtpVerification) {
                    customerOtpRequired = true;
                } else if (isPrimaryEmail && enableMobileOtpVerification) {
                    customerOtpRequired = true;
                }
                
                if (customerOtpRequired) {
                    // Customer OTP is required, check if verified
                    if (isOtpVerified) {
                        return (
                            <CustomButton
                                type="submit"
                                text="Proceed To Pay"
                                className={classes.PaymentForm__Submit}
                                isLoading={isFormSubmitApiLoading}
                            />
                        );
                    } else {
                        return null;
                    }
                } else {
                    // No OTP required at all, show button
                    return (
                        <CustomButton
                            type="submit"
                            text="Proceed To Pay"
                            className={classes.PaymentForm__Submit}
                            isLoading={isFormSubmitApiLoading}
                        />
                    );
                }
            }
        }

        // Original flow (unchanged)
        if ((mobileInput && enableMobileOtpVerification) || (emailInput && enableEmailOtpVerification)) {
            if (isOtpVerified) {
                return (
                    <CustomButton
                        type="submit"
                        text="Proceed To Pay"
                        className={classes.PaymentForm__Submit}
                        isLoading={isFormSubmitApiLoading}
                    />
                );
            } else {
                return null;
            }
        } else {
            return (
                <CustomButton
                    type="submit"
                    text="Proceed To Pay"
                    className={classes.PaymentForm__Submit}
                    isLoading={isFormSubmitApiLoading}
                />
            );
        }
    };

    if (!blockUnverifiedStudent) {
        if (studentDetails) {
            return isActiveStudent ? <div className={classes.PaymentForm__Actions}>{renderFormButton()}</div> : null;
        } else {
            return studentDetailsApiCount > 0 ? <div className={classes.PaymentForm__Actions}>{renderFormButton()}</div> : null;
        }
    }

    return (
        <div className={classes.PaymentForm__Actions}>
            {isStudentVerified && studentDetails && <>{isActiveStudent && renderFormButton()}</>}
        </div>
    );
};

CfButtonSection.propTypes = {
    formBlockData: PropTypes.object,
    studentDetails: PropTypes.object,
    isStudentVerified: PropTypes.bool,
    studentDetailsApiCount: PropTypes.number,
    isOtpVerified: PropTypes.bool,
    isFormSubmitApiLoading: PropTypes.bool,
    isPrimaryIdentifierFlow: PropTypes.bool,
    isPrimaryOtpVerified: PropTypes.bool,
};

export default CfButtonSection;
